import { ServerLogger as ServerLoggerType } from '../../types/ServerLogger';

export class ServerLogger {
  private logger: ServerLoggerType | undefined = void 0;

  set(logger: ServerLoggerType) {
    this.logger = logger;
  }

  get() {
    return this?.logger ? this.logger : console;
  }
}
